// extracted by mini-css-extract-plugin
module.exports = {"link":"LoginLayout_link__1FR3T"};